import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { combineLatest, map, Observable } from 'rxjs';
import { McpService } from '../services/mcp.service';
/**
 * Check of the user should only access the Reportingpage
 */
@Injectable({
  providedIn: 'root'
})
export class ReportingGuard  {
  /**
   * constructor
   * @param mcp 
   * @param router 
   */
  constructor(
    private mcp: McpService,
    private router: Router) {

  }
/**
 * Check of the user should only access the Reportingpage
 * @param route 
 * @param state 
 * @returns 
 */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return combineLatest([
      this.mcp.loadConfiguration()
    ]).pipe(
      map((config: any) => {
        if (config[0].SB_MENU) {
          if (config[0].SB_MENU[0].label == "Reports") {
            return this.router.createUrlTree(['/caseworker/report']);
          } else {
            return true;
          }
        } else {
          return true;
        }
      })
    )
  }

}
